import React, { useState } from "react";
import PropTypes from "prop-types";
import { Typography, Grid } from "@material-ui/core";
import ErrorIcon from "@material-ui/icons/Error";
import alternateCountryTranslations from "infrastructure/translate/alternateCountyTranslations";
import analytics from "app/segment";
import { EventNames } from "v2/infrastructure/common/eventsDictionary/EventNames";
import Modal from "../Modal";
import { translate as t } from "../../../../infrastructure/translate/localization";
import useStyles from "./styles";
import { hideModal } from "../../../../usecases/commons/hide-modal";
import CobeeButton from "../../CobeeButton";
import CobeeCheckbox from "../../CobeeCheckbox";

export default function ConfirmBagRemovalModal({ country, callback }) {
  const {
    container,
    row,
    checkboxContainer,
    checkboxText,
    icon,
    buttonRow,
    bullet,
  } = useStyles();

  const [shouldNotifyEmployees, setShouldNotifyEmployees] = useState(true);

  const handleDeleteCancel = async () => {
    await analytics.track(EventNames.DELIVERY_DELETE_CANCEL_CLICKED);
    hideModal();
  };

  const handleDeleteConfirm = async () => {
    await analytics.track(EventNames.DELIVERY_DELETE_CONFIRM_CLICKED, {
      shouldNotifyEmployees,
    });
    callback(shouldNotifyEmployees);
  };

  return (
    <Modal>
      <Grid item xs={12} container className={container}>
        <Grid container item xs={12} justify="center">
          <ErrorIcon className={icon} />
        </Grid>
        <Grid container item xs={12}>
          <Grid item container xs={12} justify="center" className={row}>
            <Typography variant="h6">
              {t("subsidy-section.bag-removal-warning")}
            </Typography>
          </Grid>
          <Grid item container xs={12} className={row} direction="row">
            <Grid item xs={1} container justify="flex-end">
              <div className={bullet} />
            </Grid>
            <Grid item xs={10}>
              <Typography variant="body2">
                {t("subsidy-section.bag-removal-tooltip-1")}
              </Typography>
            </Grid>
          </Grid>
          <Grid item container xs={12} className={row} direction="row">
            <Grid item xs={1} container justify="flex-end">
              <div className={bullet} />
            </Grid>
            <Grid item xs={10}>
              <Typography variant="body2">
                {t("subsidy-section.bag-removal-tooltip-2")}
              </Typography>
            </Grid>
          </Grid>
          <Grid item container xs={12} className={row} direction="row">
            <Grid item xs={1} container justify="flex-end">
              <div className={bullet} />
            </Grid>
            <Grid item xs={10}>
              <Typography variant="body2">
                {alternateCountryTranslations(country, "bag-removal-tooltip-3")}
              </Typography>
            </Grid>
          </Grid>
          <Grid item container xs={12} className={row} direction="row">
            <Grid item xs={1} container justify="flex-end">
              <div className={bullet} />
            </Grid>
            <Grid item xs={10}>
              <Typography variant="body2">
                {t("subsidy-section.bag-removal-tooltip-4")}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={1} />
        <Grid
          className={row}
          container
          alignItems="center"
          item
          xs={11}
          onClick={() => setShouldNotifyEmployees((prev) => !prev)}
        >
          <CobeeCheckbox
            className={checkboxContainer}
            checked={shouldNotifyEmployees}
          />
          <Typography variant="body2" className={checkboxText}>
            {t("common-messages.notify-employees")}
          </Typography>
        </Grid>
        <Grid item xs={12} container justify="center" className={buttonRow}>
          <CobeeButton styleType="secondary" onClick={handleDeleteCancel}>
            {t("actions.cancel")}
          </CobeeButton>
          <CobeeButton variant="contained" onClick={handleDeleteConfirm}>
            {t("actions.confirm")}
          </CobeeButton>
        </Grid>
      </Grid>
    </Modal>
  );
}

ConfirmBagRemovalModal.defaultProps = { country: "ES" };

ConfirmBagRemovalModal.propTypes = {
  callback: PropTypes.func.isRequired,
  country: PropTypes.string,
};
